import { render, staticRenderFns } from "./IncidentWorkflowRightBar.vue?vue&type=template&id=61fa3b6a&"
import script from "./IncidentWorkflowRightBar.vue?vue&type=script&lang=js&"
export * from "./IncidentWorkflowRightBar.vue?vue&type=script&lang=js&"
import style0 from "./IncidentWorkflowRightBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports